import type { LimitOrderAmendRequest, LimitOrderResponse } from 'apiConnector/secondary-market/limit-order/models';
import { secondaryMarketAmendActionsFactory } from 'state/secondaryMarket/shared/amend/amend.actions';

export const limitOrderAmendActions = secondaryMarketAmendActionsFactory<
  LimitOrderAmendRequest,
  LimitOrderResponse,
  'LIMIT_ORDER'
>('LIMIT_ORDER');

type TypeofLimitOrderAmendActions = typeof limitOrderAmendActions;
export type SecondaryMarketLimitOrderAmendRequested = ReturnType<
  TypeofLimitOrderAmendActions['secondaryMarketAmendRequested']
>;
export type SecondaryMarketLimitOrderAmendReceived = ReturnType<
  TypeofLimitOrderAmendActions['secondaryMarketAmendReceived']
>;
export type SecondaryMarketLimitOrderAmendFailed = ReturnType<
  TypeofLimitOrderAmendActions['secondaryMarketAmendFailed']
>;
export type SecondaryMarketLimitOrderAmendRejected = ReturnType<
  TypeofLimitOrderAmendActions['secondaryMarketAmendRejected']
>;
export type SecondaryMarketLimitOrderAmendCollided = ReturnType<
  TypeofLimitOrderAmendActions['secondaryMarketAmendCollided']
>;

export type SecondaryMarketLimitOrderAmendActions = ReturnType<
  TypeofLimitOrderAmendActions[keyof TypeofLimitOrderAmendActions]
>;
